import "backboneAjaxQAdapter";

import GenericView from 'views/generic.view.ts';

import Handlebars from 'handlebars';
import Template from 'text-loader!../../../../templates/analytics/venues/queues/analytics_queues_statistics.template.html';

import Collection from '../../../../models/queues_statistics.paginated.collection.ts';

import colors from '../../../../../libs/assets/colors.js';
import i18n  from "l10n";

import QueuePieChartView from './queue_pie_chart.view.ts';
import QueuesLineChartView from './queue_line_chart.view.ts';

export default GenericView.extend({
    el: "#statistics-container",
    tagName: 'div',
    className: 'venue-statistic',
	template: Handlebars.compile(Template),
	venueId: null,
	from: null,
	to: null,
    initialize: function (options) {
        var self = this;

        this.venueId = options ? options.venueId : null;
        this.from = options ? options.from : null;
        this.to = options ? options.to : null;

	},
	superRender: Backbone.View.prototype.render,
	render: function () {
		var self = this;
		this.superRender();

        var templateParams = $.extend({}, this.collection.models, {"lang": i18n.lng()});
        var templateData = this.template( templateParams );

		this.$el.html( templateData );

        return this;
	},
	events:{

    },
    getCollectionUrl: function() {
        return "rest/api/statistics/venues/"+this.venueId+"/queues";
    },
    loadData: function() {
        if(!this.venueId || this.venueId < 1 || !this.from || !this.to) {
            // todo: show error message
            return;
        }

        var self = this;
        this.collection = new Collection();

        this.collection.url = this.getCollectionUrl() + "?extra=queue&filter=" + encodeURIComponent("date>=" + this.from + ", date<=" + this.to) + "&group=queue";

        this.collection.on( 'sync',
            function() {
                self.successQueueStatisticsData();
            }
        , this );
        this.collection.on( 'error', this.errorQueueStatisticsData, this );
        this.collection.getFirstPage();
    },
    successQueueStatisticsData: function() {
        var $statsContainer = this.$el;
        $statsContainer.empty();

        this.render();

        if (this.collection.models.length > 0) {
            $statsContainer.find("#chartdiv-card").show();
            $statsContainer.find("#errorqueues").hide();

            // show "Export Data" button
            $statsContainer.find(".export-data").show();
            $statsContainer.find(".export-data").find("#export-link").attr("href", this.getCollectionUrl() + "/export?lang="+ i18n.lng() +"&filter=" + encodeURIComponent("date>=" + this.from + ", date<=" + this.to));


            var queuesLineChartView = new QueuesLineChartView({"data": this.collection.models});
            queuesLineChartView.render();

            this.renderPieCharts();
        }
        else {
            $statsContainer.find("#chartdiv-card").hide();
            $statsContainer.find("#errorqueues").show();

            // hide "Export Data" button
            $statsContainer.find(".export-data").hide();
            $statsContainer.find(".export-data").find("#export-link").removeAttr("href");
        }
    },
    errorQueueStatisticsData: function(collection, xhr, options) {
        this.onErrorHandler(collection, xhr, options);

    },
    renderPieCharts: function() {
        // clear pies container
        this.$el.find("#queues_statistics-container").empty();

        for(var i = 0; i< this.collection.models.length; i++) {
            var tempModel = this.collection.models[i];

            var queuePieChartView = new QueuePieChartView({"data": tempModel.attributes});

            this.$el.find("#queues_statistics-container").append( queuePieChartView.render().el );
        }
    }

});


